import styled, { css } from 'styled-components'

import { Color } from 'constants/color'
import { hexToRgba } from 'helpers/miscellaneous'
import { isIPad } from 'utils/utils'

export const enabledButtonColor = name => {
    if (name === 'cancel' || name === 'stop') {
        return '#E87D7C;'
    } else if (name === 'continue' || name === 'break away') {
        return '#95C48C;'
    } else {
        return '#ef5c34;'
    }
}

export const OHButton = styled.button`
    background: ${props =>
        props.disabled ? '#e0e0e0' : enabledButtonColor(props.name)}
    font-size:14px
    font-style: normal;
    font-weight: 600;
    color: ${props => (props.disabled ? '#555' : '#fff')};

    padding: 0% 3%;
    max-width: max-content;
    border: none;
    border-radius: 10vh;
    max-height: max-content;
    width: ${props => (props.name === 'break away' ? '10vw' : '8vw')};
    height: 4vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: 30;
    outline: none;
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    font-family: ${isIPad ? `AvenirBold` : `Avenir`};
    letter-spacing: ${isIPad ? `-0.5px` : ``};
    @media only screen and (max-width: 1366px) and (max-height: 1024px) {
        padding: 10px 3%;
        width: inherit;
        min-width: 9vw;
    }
`

export const ButtonImg = styled.img`
    width: 10px;
    height: 10px;
    margin-left: 15px;
`

export const Content = styled.div`
    width: inherit;
`

export const GenericButtonComponent = styled.button`
    border-radius: 8px;
    text-transform: lowercase;
    font-weight: 700;
    width: 216px;
    height: 53px;
    font-family: Avenir;
    cursor: ${props => (!props.disabled ? 'pointer' : 'not-allowed')};
    margin: 4px;
    margin-left: 16px;
`

export const SuccessButtonComponent = styled(GenericButtonComponent)`
    background-color: ${props =>
        props.disabled ? Color.unknownColor14 : Color.ohGreen};
    color: ${Color.black};
    border: none;

    ${props =>
        props.isLoading &&
        css`
            pointer-events: none;
        `};
    &:hover {
        background: ${props =>
            props.disabled ? Color.unknownColor14 : Color.ohGreenHover};
    }
`

export const CancelButtonComponent = styled(GenericButtonComponent)`
    background-color: transparent;
    border: 2px solid ${Color.ohRed};
    color: ${Color.ohRed};
    &:hover {
        background: ${hexToRgba(Color.ohRed, 0.1)};
    }
`
